// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sn-logo {
  position: absolute;
  top: 10px;
  left: 80px;
}

.sn-logo img {
  width: 65%;
}
  
  
  .frg-btn h6 {
  
  cursor: pointer;
}

.sigin-new-left {
  display: flex;
  align-items: center;
  justify-items: center;
  background-color: #f6f6f6;
  padding: 0 240px;
  padding-top: 20px;
  position: relative;
  height: 100vh;
}

.sigin-new-right {
  background-color: #55b56d;
  padding: 87px 45px;
 padding-bottom: 235px; 
 height: 100vh;
  
  
}

.ggl-sing img {
  width: 16%;
  margin-right: 8px;
}

.ggl-sing {
  border: 1px solid #ccc;
  padding: 6px 20px;
  border-radius: 5px;
  color: #000;
  text-align: center;
  background-color: #fff;
  width: 100%;
  display: block;

}

.sinfrnw h6 a {
  text-decoration: underline;
}

.prvtrm {
  font-size: 13px;
  color: #212529;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-top: 5px;
  display: block;
  text-align: center;
}


.sinfrnw label {
  font-size: 14px;
  font-weight: 400;
  color: #212529;
  font-family: 'Poppins';
  margin-top: 10px;
  margin-bottom: 5px;
}

.sinfrnw h4 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 25px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
}

.btn.btre {
  border-radius: 0.25rem;
  margin-bottom: 12px;
}

.sinfrnw h6 {
  text-align: center;
  font-size: 15px;
}

a.frg-btn {
  display: block;
}

.with-sngnw {
  padding: 0px;
  margin: 0px;
  display: flex;
  justify-content: space-between;
}

.with-sngnw li {
  float: left;
  width: 100%;
}

.sigin-new-right h4 {
  text-align: center;
  margin-bottom: 15px;
  font-size: 28px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
}

.sigin-new-right h5 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  color: #fff;
  margin-top: 20px;
}

.prvtrm a {
  text-decoration: underline;
}


.field-icon {
  float: right;
  margin-left: -28px;
  margin-top: -47px;
  position: relative;
  z-index: 2;
}

.sign-frw {
  font-size: 15px;
  font-family: 'Poppins';
  text-align: right;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/pages/Signin/Signin.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;;EAGE;;EAEA,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;CACnB,qBAAqB;CACrB,aAAa;;;AAGd;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,cAAc;;AAEhB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".sn-logo {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 80px;\r\n}\r\n\r\n.sn-logo img {\r\n  width: 65%;\r\n}\r\n  \r\n  \r\n  .frg-btn h6 {\r\n  \r\n  cursor: pointer;\r\n}\r\n\r\n.sigin-new-left {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-items: center;\r\n  background-color: #f6f6f6;\r\n  padding: 0 240px;\r\n  padding-top: 20px;\r\n  position: relative;\r\n  height: 100vh;\r\n}\r\n\r\n.sigin-new-right {\r\n  background-color: #55b56d;\r\n  padding: 87px 45px;\r\n padding-bottom: 235px; \r\n height: 100vh;\r\n  \r\n  \r\n}\r\n\r\n.ggl-sing img {\r\n  width: 16%;\r\n  margin-right: 8px;\r\n}\r\n\r\n.ggl-sing {\r\n  border: 1px solid #ccc;\r\n  padding: 6px 20px;\r\n  border-radius: 5px;\r\n  color: #000;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  width: 100%;\r\n  display: block;\r\n\r\n}\r\n\r\n.sinfrnw h6 a {\r\n  text-decoration: underline;\r\n}\r\n\r\n.prvtrm {\r\n  font-size: 13px;\r\n  color: #212529;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  line-height: 28px;\r\n  margin-top: 5px;\r\n  display: block;\r\n  text-align: center;\r\n}\r\n\r\n\r\n.sinfrnw label {\r\n  font-size: 14px;\r\n  font-weight: 400;\r\n  color: #212529;\r\n  font-family: 'Poppins';\r\n  margin-top: 10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.sinfrnw h4 {\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n  font-size: 25px;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n}\r\n\r\n.btn.btre {\r\n  border-radius: 0.25rem;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.sinfrnw h6 {\r\n  text-align: center;\r\n  font-size: 15px;\r\n}\r\n\r\na.frg-btn {\r\n  display: block;\r\n}\r\n\r\n.with-sngnw {\r\n  padding: 0px;\r\n  margin: 0px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.with-sngnw li {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.sigin-new-right h4 {\r\n  text-align: center;\r\n  margin-bottom: 15px;\r\n  font-size: 28px;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n}\r\n\r\n.sigin-new-right h5 {\r\n  text-align: center;\r\n  margin-bottom: 20px;\r\n  font-size: 16px;\r\n  font-family: 'Poppins';\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  color: #fff;\r\n  margin-top: 20px;\r\n}\r\n\r\n.prvtrm a {\r\n  text-decoration: underline;\r\n}\r\n\r\n\r\n.field-icon {\r\n  float: right;\r\n  margin-left: -28px;\r\n  margin-top: -47px;\r\n  position: relative;\r\n  z-index: 2;\r\n}\r\n\r\n.sign-frw {\r\n  font-size: 15px;\r\n  font-family: 'Poppins';\r\n  text-align: right;\r\n  display: block;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
